import { Slot } from '@bcraft-frontend-lib/slots'

import Api from 'services/api'

import { Providers } from 'modules/SlotsRoot/types/configuration'

export const OUTCOME_INTEGRATION_NAME = 'cf73bd58'

const slotsApi = new Api('')

let cachedOutcomeFreeSpinGameIds: Set<string> | null = null
let loadOutcomeFreeSpinGameIdsPromise: Promise<Set<string>> | null = null

export const fetchOutcomeFreeSpinGameIds = async (): Promise<Set<string>> => {
  if (cachedOutcomeFreeSpinGameIds) {
    return cachedOutcomeFreeSpinGameIds
  }

  if (!loadOutcomeFreeSpinGameIdsPromise) {
    loadOutcomeFreeSpinGameIdsPromise = slotsApi.slots
      .getGameList({ id: 'outcome', provider: Providers.OUTCOME })
      .then(response => {
        if (!response.success) {
          cachedOutcomeFreeSpinGameIds = new Set<string>()
          return cachedOutcomeFreeSpinGameIds
        }

        const ids = response.data
          .filter(game => game.hasFreeSpins)
          .map(game => game.gameId)

        cachedOutcomeFreeSpinGameIds = new Set(ids)

        return cachedOutcomeFreeSpinGameIds
      })
      .catch(() => {
        cachedOutcomeFreeSpinGameIds = new Set<string>()
        return cachedOutcomeFreeSpinGameIds
      })
  }

  return loadOutcomeFreeSpinGameIdsPromise
}

export const filterFreeSpinSlotsByOutcome = (
  catalogSlots: Slot[],
  outcomeFreeSpinGameIds: Set<string> | null,
): Slot[] => {
  if (!outcomeFreeSpinGameIds) {
    return []
  }

  return catalogSlots.filter(
    slot =>
      slot.integrationName === OUTCOME_INTEGRATION_NAME &&
      outcomeFreeSpinGameIds.has(slot.externalId),
  )
}
